import type { JourneyProgress } from '../types/workspace';

const STATE = {
  done: { dot: 'bg-emerald-500', text: 'text-emerald-700', mark: '✓' },
  current: { dot: 'bg-[#d6006e]', text: 'text-[#6b0030]', mark: '•' },
  blocked: { dot: 'bg-rose-500', text: 'text-rose-700', mark: '!' },
  upcoming: { dot: 'bg-slate-300', text: 'text-slate-500', mark: '' },
};

export default function ProgressTracker({ progress }: { progress?: JourneyProgress | null }) {
  if (!progress?.stages?.length) return null;
  return (
    <section className="mt-5 rounded-2xl border border-[#fce7f3] bg-white p-4" aria-label="Application progress">
      <div className="flex items-center justify-between gap-3">
        <h2 className="text-xs font-black uppercase tracking-[0.14em] text-[#6b0030]">Application progress</h2>
        <p className="text-xs font-semibold text-[#d6006e]">{progress.nextAction}</p>
      </div>
      <ol className="mt-4 grid gap-3 sm:grid-cols-3 lg:grid-cols-6">
        {progress.stages.map((stage) => {
          const style = STATE[stage.state];
          return (
            <li key={stage.key} className="relative min-w-0">
              <div className="flex items-center gap-2">
                <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-black text-white ${style.dot}`}>{style.mark}</span>
                <span className={`text-xs font-bold ${style.text}`}>{stage.label}</span>
              </div>
              <p className="mt-1 pl-8 text-xs leading-snug text-[#9a6b82]">{stage.detail}</p>
            </li>
          );
        })}
      </ol>
      {progress.blocking.length > 0 && <p className="mt-3 border-t border-[#fce7f3] pt-3 text-xs font-semibold text-rose-700">{progress.blocking[0]}</p>}
    </section>
  );
}
